import { useState } from "react";
import type { DomainExpenseType } from "@porchpass/api-client";
import type { ExpenseFormData } from "src/types/expenses";
import { ExpenseOptions } from "src/constants";
import DeleteExpenseModal from "../DeleteExpenseModal";
import { toFormattedInteger } from "src/utils";
import { FormTableSummaryCard, MoneySecurityIcon } from "@porchpass/ui";

const formatDateRange = (from?: string, to?: string): string => {
  const formatDate = (date: string) =>
    new Date(date).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      timeZone: "UTC",
    });

  if (from && to) {
    return `From ${formatDate(from)} to ${formatDate(to)}`;
  }
  if (from) {
    return `Since ${formatDate(from)}`;
  }
  if (to) {
    return `Ends on ${formatDate(to)}`;
  }
  return "";
};

const typeToTitle = (type: DomainExpenseType) =>
  ExpenseOptions.find((item) => item.expense_type === type)?.title;

type ExpenseItemProps = {
  expense: ExpenseFormData;
  index?: number;
  editHandler: () => void;
  closeHandler: () => void;
  deleteHandler: () => void;
};

export default ({
  expense,
  index = 0,
  editHandler,
  closeHandler,
  deleteHandler,
}: ExpenseItemProps) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const dateRange = formatDateRange(expense.start_date, expense.end_date);

  return (
    <>
      <FormTableSummaryCard
        index={index}
        title={
          expense.expense_type
            ? (typeToTitle(expense.expense_type) ?? "Expense")
            : "Expense"
        }
        icon={
          <MoneySecurityIcon
            variant="bulk-rounded"
            size={16}
            className="text-[#017C3F]"
          />
        }
        subtitles={dateRange ? [dateRange] : undefined}
        amount={{
          value: `$${toFormattedInteger(expense.amount)}`,
          suffix: "mo",
        }}
        onClick={editHandler}
        onEdit={editHandler}
        onDelete={() => setModalOpen(true)}
      />
      <DeleteExpenseModal
        isOpen={isModalOpen}
        expense_id={expense.id ?? ""}
        closeHandler={() => {
          setModalOpen(false);
          closeHandler();
        }}
        deleteHandler={() => {
          setModalOpen(false);
          deleteHandler();
        }}
      />
    </>
  );
};
